import React, { useState } from 'react'
import {
    Box,
    Button,
    Card,
    Divider,
    Flex,
    Step,
    StepIcon,
    StepIndicator,
    StepNumber,
    Stepper,
    StepSeparator,
    StepStatus,
    Text,
    useSteps,
    VStack
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import Header from '../../../components/Header'
import {  } from '@chakra-ui/icons';
import { CampaignDetails } from './CampaignDetails/CampaignDetails'
import { CommunicationChannels } from './CommunicationChannels/CommunicationChannels'
import { TemplateSelection } from './TemplateSelection/TemplateSelection'
import { TargetContacts } from './TargetContacts/TargetContact'
import TemplateVariableConfig from './TemplateVariableConfig/TemplateVariableConfig'
import CampaignReviewSubmit from './ReviewCampaign/ReviewCampaign'
import { toast } from 'react-toastify'
import { LuArrowLeft } from 'react-icons/lu'
import { getUserTimeZone } from '../../../utils/DefaultFunction'

const Campaign = ({ header }) => {
    const navigate = useNavigate()
    const [currentStep, setCurrentStep] = useState(0)

    const [formData, setFormData] = useState({
        // Campaign Details section
        campaignName: '',
        campaignType: '3',
        description: '',

        // Communication Channels section
        selectedChannels: [],

        // Template Selection section
        selectedTemplate: null,
        sendToAll: false,
        selectedTags: [],
        targetAudience: [],
        audienceCount: 0,
        allContactsTotal: {},
        taggedContactTotal: {},
        selectedCohort: {},
        cohortsContact: 0,
        timezone: getUserTimeZone(),
        audienceType:"all_contacts"
    });

    const extractVariables = (message) => {
        if (!message) return [];
        const variableRegex = /\$(\w+)/g;
        const matches = [];
        let match;

        while ((match = variableRegex.exec(message)) !== null) {
            if (!matches.includes(match[1])) {
                matches.push(match[1]);
            }
        }

        return matches;
    };


    const validate = () => {
        if (!formData.campaignName) {


            return true;
        }
        if (!formData.campaignType) {



            return true;
        }
        if (formData.sendToAll === false && formData?.selectedTags?.length === 0 && activeStep === 1 && !formData?.selectedCohort?._id) {



            return true;
        }

        // if (formData.selectedChannels.length === 0) {
        //     alert('Please select at least one communication channel');
        //     return;
        // }

        if (!formData.selectedTemplate?.id) {

            return true;
        }



        // When user tries to move forward (e.g. at activeStep === 2)
        if (activeStep === 2) {

            const messageCombine = JSON.parse(formData?.selectedTemplate?.message_combine || '{}');
            const variables = (messageCombine.variables || []).map((v) => v.name);
            const variableValues = formData?.template_variables || {};

            // Find missing variable values
            const missingVariables = variables.filter((variable) => {
                const v = variableValues[variable];
                return !v || !v.value?.trim(); // either missing or empty string
            });


            if (missingVariables.length > 0) {

                return true;
            }
        }
    }

    const handleContinue = () => {

        // Validate all Step 1 form data before proceeding || !formData.campaignType
        if (!formData.campaignName) {
            toast.warning("Please Enter campaign name")

            return;
        }
        if (!formData.campaignType) {
            toast.warning("Please select campaign type")


            return;
        }
        if (formData.sendToAll === false && formData?.selectedTags?.length === 0 && activeStep === 1 && !formData?.selectedCohort?._id) {
            toast.warning("Please Select Target Audience")


            return;
        }

        // if (formData.selectedChannels.length === 0) {
        //     alert('Please select at least one communication channel');
        //     return;
        // }

        if (!formData.selectedTemplate?.id) {
            toast.warning('Please select a template');
            return;
        }



        // When user tries to move forward (e.g. at activeStep === 2)
        if (activeStep === 2) {

            const messageCombine = JSON.parse(formData?.selectedTemplate?.message_combine || '{}');
            const variables = (messageCombine.variables || []).map((v) => v.name);
            const variableValues = formData?.template_variables || {};

            // Find missing variable values
            const missingVariables = variables.filter((variable) => {
                const v = variableValues[variable];
                return !v || !v.value?.trim(); // either missing or empty string
            });


            if (missingVariables.length > 0) {


                toast.warning(
                    `Please provide values for: ${missingVariables.join(', ')}`
                );
                return;
            }
        }



        // Here you can:
        // 1. Save formData to parent component state
        // 2. Move to Step 2 of the campaign creation
        // 3. Call a callback function passed from parent
        // alert('Step 1 completed! Moving to Step 2...');
        setActiveStep(currentStep + 1)
        setCurrentStep(currentStep + 1)
    };
    function handleBack() {
        setActiveStep(currentStep - 1)
        setCurrentStep(currentStep - 1)
    }

    const steps = [
        { title: 'First', description: 'Contact Info' },
        { title: 'Second', description: 'Date & Time' },
        { title: 'Third', description: 'Select Rooms' },
        { title: 'Fourth', description: 'Select Rooms' },
    ]


    const { activeStep, setActiveStep } = useSteps({
        index: currentStep,
        count: steps.length,
    })

    const handleStepClick = (step) => {
        // If clicking the same step, ignore
        if (step === activeStep) return;

        // If user is trying to move forward → run validation
        if (step > activeStep) {
            const isInvalid = validate(); // your custom validation
            if (isInvalid) {
                toast.warning("Please complete current step before proceeding");
                return; // block moving forward
            }
        }

        // Otherwise (going backward or valid forward) — move to clicked step
        setActiveStep(step);
        setCurrentStep(step);
    };

    const handleNavigateBack = (step) => {
        navigate(-1)
    }


    function getTitle(steps) {
        switch (steps) {
            case 1:
                return "Campaign Details & Template Selection"

            case 2:
                return "Audience Selection"

            case 3:
                return "Template Variables"
            case 4:
                return "Channel Selection & Review & Launch"


            default:
                return ""
        }
    }

    return (
        <>
            <Header header={header} />
            <Card className='card-style' style={{ margin: "20px 40px" }} shadow={'xl'}>

                <Box style={{ width: "100%", padding: "20px" }} py={8}>
                    <Box>
                        {/* <Flex gap={6} alignItems="center"> */}
                        <Button


                            variant="outline"
                            size="sm"
                            borderRadius="md"
                            _hover={{ bg: "#0000001a !important", color: "black !important" }}
                            onClick={handleNavigateBack}

                        >
                            <LuArrowLeft style={{ marginRight: ".5rem" }} /> Back To Campaigns
                        </Button>
                        <Flex direction="column">
                            <Text fontSize="2xl" fontWeight="semibold">Create New Campaign</Text>
                            <Text fontSize="sm" fontWeight="semibold">Step {activeStep + 1} of 4: {getTitle(activeStep + 1)}</Text>
                        </Flex>
                        {/* </Flex> */}
                    </Box>

                    <Flex justifyContent={"center"} alignItems={"center"}>
                        <Box mt={8} width={"30%"}>

                            <Stepper
                                index={currentStep}
                                colorScheme='blue'
                                sx={{
                                    '& .chakra-step__indicator[data-status="active"]': {
                                        backgroundColor: 'var(--brand-primary)',
                                        borderColor: 'var(--brand-primary)',
                                        color: 'white'
                                    },
                                    '& .chakra-step__indicator[data-status="complete"]': {
                                        backgroundColor: 'var(--brand-primary)',
                                        borderColor: 'var(--brand-primary)',
                                        color: 'white'
                                    },
                                    '& .chakra-step__separator[data-status="complete"]': {
                                        backgroundColor: 'var(--brand-primary)'
                                    },
                                    '& .chakra-step__indicator[data-status="incomplete"]': {
                                        borderColor: '#e2e8f0',
                                        backgroundColor: 'white',
                                        color: '#a0aec0'
                                    }
                                }}
                            >
                                {steps.map((step, index) => (

                                    <Step key={index} onClick={() => handleStepClick(index)}>
                                        <StepIndicator>
                                            <StepStatus
                                                complete={<StepIcon />}
                                                incomplete={<StepNumber />}
                                                active={<StepNumber />}
                                            />
                                        </StepIndicator>

                                        <StepSeparator />
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                    </Flex>

                    <VStack spacing={6} align="stretch" mt={6}>
                        <Box className='box-style-card'>

                            {activeStep === 0 && (
                                <>
                                    {/* Section 1: Campaign Details */}
                                    <CampaignDetails formData={formData} setFormData={setFormData} />



                                    {/* Section 3: Template Selection */}
                                    <TemplateSelection formData={formData} setFormData={setFormData} />
                                </>
                            )}
                            {activeStep === 1 && (
                                <TargetContacts formData={formData} setFormData={setFormData} />
                            )}
                            {activeStep === 2 && (
                                <TemplateVariableConfig formData={formData} setFormData={setFormData} />
                            )}
                            {activeStep === 3 && (
                                <>
                                    <CommunicationChannels formData={formData} setFormData={setFormData} />
                                    <Divider />
                                    <CampaignReviewSubmit
                                        formData={formData}
                                        setFormData={setFormData}
                                        setActiveStep={setActiveStep}
                                        setCurrentSteps={setCurrentStep}
                                        currentStep={currentStep}
                                        step={steps}
                                        back={handleBack}
                                        onSubmitSuccess={(response) => {

                                            // Redirect to campaigns list or show success message
                                            navigate('/marketing/campaign');
                                        }}
                                    />
                                </>
                            )}
                        </Box>
                        {activeStep !== 3 && (
                            <Flex justify="space-between" pt={4} borderTop="1px solid" borderColor="gray.200">
                                <Button
                                    variant="outline"
                                    colorScheme="gray"
                                    onClick={handleBack}
                                    px={8}
                                    disabled={activeStep === 0}
                                >
                                    Previous
                                </Button>

                                <Button
                                    bg="var(--brand-primary)"
                                    color="white"
                                    onClick={handleContinue}
                                    px={8}
                                    _hover={{ bg: "var(--brand-primary-active)" }}
                                    disabled={validate()}
                                >
                                    Next
                                </Button>
                            </Flex>
                        )}
                        {/* Step 1 Navigation Buttons */}

                    </VStack>
                </Box>
            </Card>
        </>
    )
}

export default Campaign